// Needed for redux-saga es6 generator support
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import '@okta/okta-auth-js/polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

// Import Tailwind CSS for ga-ui components
import './ga-ui/styles/globals.css';
import { ConnectedRouter } from 'connected-react-router/immutable';
import history from './store/history';
import 'sanitize.css/sanitize.css';
import 'font-awesome/css/font-awesome.min.css';
import 'typeface-open-sans';
import { initializeAnalytics } from './components/utilities/analytics';
import { initializeTracking } from './components/utilities/smartlook';

// Import root app
import './client/styles/index.less';
import App from './components/landing';

// Import Language Provider
import LanguageProvider from './components/language-provider';

// Import API Version Provider
import { ApiVersionProvider } from './context/ApiVersionContext';

// App-wide toast renderer
import { Toaster } from './ga-ui/components/custom/toaster';

import configureStore from './store/configureStore';

// Import i18n messages
import { translationMessages } from './i18n';

initializeAnalytics();
initializeTracking();
// Create redux store with history
const initialState = {};
const store = configureStore(initialState, history);
const MOUNT_NODE = document.getElementById('root');
const render = (messages) => {
  ReactDOM.render(
    <Provider store={store}>
      <LanguageProvider messages={messages}>
        <ApiVersionProvider>
          <ConnectedRouter history={history}>
            <App />
            <Toaster />
          </ConnectedRouter>
        </ApiVersionProvider>
      </LanguageProvider>
    </Provider>,
    MOUNT_NODE
  );
};

if (module.hot) {
  // Hot reloadable React components and translation json files
  // modules.hot.accept does not accept dynamic dependencies,
  // have to be constants at compile-time
  module.hot.accept(['./i18n', './components/landing'], () => {
    ReactDOM.unmountComponentAtNode(MOUNT_NODE);
    render(translationMessages);
  });
}

// Chunked polyfill for browsers without Intl support
if (!window.Intl) {
  new Promise((resolve) => {
    resolve(import('intl'));
  })
    .then(() => Promise.all([import('intl/locale-data/jsonp/en.js')]))
    .then(() => render(translationMessages))
    .catch((err) => {
      throw err;
    });
} else {
  render(translationMessages);
}
